// import DataLayer from "../../effects/utility/api/data-layer";
import axios from "axios";
import { AUTH_TOKEN, APP_NAME } from "../../constants/api";
import {
  GET_USER_PROFILE_DETAILS,
  POST_USER_PROFILE_DETAILS,
  POST_USER_PROFILE_SETTING,
  DELETE_USER_PROFILE,
  GET_ALL_USER_PROFILE_DETAILS,
  GET_IS_AUTHETICATED,
  POST_USER_ACCESS_REQUEST,
  PUT_USER_PROFILE_DETAILS,
} from "./constants";

// const dataLayer = new DataLayer();

const api = axios.create({
  baseURL: `${(window as any).SiteSettings.API_BASE_PATH}`,
});

api.interceptors.request.use(
  (config) => {
    config.headers.AppName = APP_NAME;
    config.headers.AuthenticationToken = AUTH_TOKEN;
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (err) => Promise.reject(err)
);

/**
 * Function for getting some data
 */
export const fetchUserProfileData = (lookUp: any) => {
  let url = `${GET_USER_PROFILE_DETAILS}/${lookUp}`;
  if (lookUp === "-1") {
    url = `${GET_ALL_USER_PROFILE_DETAILS}`;
  }
  return api.get(url).then(
    (resp: any) => {
      return resp;
    },
    (err: any) => {
      //console.log(err);
      return err;
    }
  );
};

export const fetchAllUserProfileData = (lookUp: any) => {
  return api.get(`${GET_ALL_USER_PROFILE_DETAILS}`).then(
    (resp: any) => {
      return resp;
    },
    (err: any) => {
      //console.log(err);
      return err;
    }
  );
};

export const saveUserProfileData = (userProfileData: any) => {
  return api.post(`${POST_USER_PROFILE_DETAILS}`, userProfileData).then(
    (resp: any) => {
      return resp;
    },
    (err: any) => {
      //console.log(err);
      return err;
    }
  );
};

export const updateUserProfileData = (userProfileData: any) => {
  return api.put(`${PUT_USER_PROFILE_DETAILS}/${userProfileData.id}`, userProfileData).then(
    (resp: any) => {
      return resp;
    },
    (err: any) => {
      //console.log(err);
      return err;
    }
  );
};


export const saveUserProfileSettingData = (userSetting: any) => {
  return api.post(`${POST_USER_PROFILE_SETTING}`, userSetting).then(
    (resp: any) => {
      return resp;
    },
    (err: any) => {
      //console.log(err);
      return err;
    }
  );
};

export const apiDeleteUserProfile = async (data: any) => {
  const url = `${DELETE_USER_PROFILE}${data}`;
  const response = await api.delete(`${url}`);
  return response;
};

export const apiAuthenticateUser = async () => {
  const response = await api.get(`${GET_IS_AUTHETICATED}`);
  return response;
};

export const apiSaveUserAccessRequest = async (data: any) => {
  const url = `${POST_USER_ACCESS_REQUEST}`;
  const response = await api.post(`${url}`, data);
  return response;
};
